import React from 'react';

function EPContactTwitter() {
  return (
    <div>EPContactTwitter</div>
  );
}

export default EPContactTwitter;
